import React from "react";
import PropTypes from "prop-types";
import { TextLink } from "@boozallen-uip/uswds-react-core";
import ExternalLinkIcon from "../../ExternalLinkIcon.component";

const infoIconSvg = (
  <svg
    className="inline mr-1 w-[1.1em] h-[1.1em]"
    style={{ verticalAlign: "-0.2em" }}
    aria-hidden
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
  </svg>
);

/**
 * External link to guidance (opens in new window).
 */
export default function LinkToGuidance({ href, showInfoIcon, children }) {
  return (
    <TextLink
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="link-to-guidance text-sm"
    >
      {showInfoIcon && infoIconSvg}
      {children}
      <ExternalLinkIcon />
      <span className="usa-sr-only"> (opens in new window)</span>
    </TextLink>
  );
}

LinkToGuidance.propTypes = {
  href: PropTypes.string.isRequired,
  showInfoIcon: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

LinkToGuidance.defaultProps = {
  showInfoIcon: false,
};
